const enquiry = (() => {

    const initBlock = el => {
        handleRemoveClick(el);
        handleQuantityClick(el);
    };

    const handleAddClick = el => {
        el.addEventListener('click', () => {
            const id = el.dataset.enquiryButton;
            fetch(`/umbraco/surface/Enquiry/Add?id=${id}`)
                .then(response => response.text())
                .then(data => {
                    el.innerHTML = data;
                    el.setAttribute('disabled', '');
                    handleUpdatePartial(document, id);
                    const overlay = document.querySelector('[data-product-added-overlay="' + id + '"]');
                    if (overlay){
                        overlay.classList.add('flex');
                        overlay.classList.remove('hidden');
                    }
                });
        });
    }

    function SetButtonText(text, itemId) {
        const overlay = document.querySelector('[data-product-added-overlay="' + itemId + '"]');
        const button = document.querySelector('[data-enquiry-button="' + itemId + '"]');
        if (button) {
            button.innerHTML = `${text}`;
            button.removeAttribute('disabled');
        }
        if (overlay) {
            overlay.classList.remove('flex');
            overlay.classList.add('hidden');
        }
    }

    const handleRemoveClick = el => {
        el.querySelectorAll('[data-enquiry-list-item]').forEach(enquiryList => {
            enquiryList.querySelectorAll('[data-remove]').forEach(removeButton => {
                removeButton.addEventListener('click', () => {
                    const dataEnquiryListTotal = document.querySelectorAll('[data-enquiry-list-total]');
                    const firstTotalItem = dataEnquiryListTotal && dataEnquiryListTotal.length > 0 ? dataEnquiryListTotal[0].innerHTML : 0;
                    const firstTotalItemValue = parseInt(firstTotalItem);
                    const quantity = enquiryList.querySelector('[data-quantity]');
                    const quantityValue = parseInt(quantity.value);
                    const newValue = (firstTotalItemValue - quantityValue).toString();
                    fetch(`/umbraco/surface/Enquiry/Quantity?id=${removeButton.dataset.remove}&quantity=0`)
                        .then(response => response.json())
                        .then(data => {
                        dataEnquiryListTotal.forEach(total => total.innerHTML = newValue);
                        if (enquiryList && enquiryList.parentNode) {
                            enquiryList.outerHTML = '';
                        }
                        SetButtonText(data.buttonText, removeButton.dataset.remove);
                    });
                });
            });
        });
    };
    
    const handleQuantityClick = (el, isNewEnquiryItem = false) => {
        const dataEnquiryListTotal = document.querySelectorAll('[data-enquiry-list-total]');
        if (dataEnquiryListTotal && isNewEnquiryItem){
            const firstTotalItem = dataEnquiryListTotal[0].innerHTML;
            const firstTotalItemValue = parseInt(firstTotalItem);
            const newValue = (firstTotalItemValue + 1).toString();
            dataEnquiryListTotal.forEach(total => total.innerHTML = newValue);
        }
        el.querySelectorAll('[data-enquiry-list-item]').forEach(enquiryList => {
            const id = enquiryList.dataset.enquiryListItem;
            const decrement = enquiryList.querySelector('[data-input-counter-decrement]');
            const increment = enquiryList.querySelector('[data-input-counter-increment]');
            
            decrement.addEventListener('click', () => {
                const quantity = enquiryList.querySelector('[data-quantity]');
                const quantityVal = parseInt(quantity.value);
                const newQuantity = quantityVal - 1;                
                fetch(`/umbraco/surface/Enquiry/Quantity?id=${id}&quantity=${newQuantity}`)
                    .then(response => response.json())
                    .then(data => {
                        dataEnquiryListTotal.forEach(total => total.innerHTML = data.count);
                        quantity.value = newQuantity;
                        if (newQuantity === 0){
                            enquiryList.outerHTML = '';
                        }
                        handleRemoveClick(el);
                        handleUpdateInput();
                        SetButtonText(data.buttonText, id);
                    });                
            });
            increment.addEventListener('click', () => {
                const quantity = enquiryList.querySelector('[data-quantity]');
                const quantityVal = parseInt(quantity.value);
                const newQuantity = quantityVal + 1;
                fetch(`/umbraco/surface/Enquiry/Quantity?id=${id}&quantity=${newQuantity}`)
                    .then(response => response.json())
                    .then(data => {
                        dataEnquiryListTotal.forEach(total => total.innerHTML = data.count);
                        quantity.value = newQuantity;
                        handleRemoveClick(el);
                        handleUpdateInput();
                    });
            });     
        });
    }

    const handleUpdatePartial = (el, id) => {
        el.querySelectorAll('[data-enquiry-list]').forEach(enquiryList => {
            fetch(`/umbraco/surface/Enquiry/Update?id=${id}`)
                .then(response => response.text())
                .then(data => {
                    const wrapper = el.querySelector('[data-enquiry-results-wrapper]');
                    wrapper.innerHTML += data;
                    handleQuantityClick(wrapper, true);
                    handleRemoveClick(wrapper);
                    handleUpdateInput();
                });
        });
    }
    
    const handleUpdateInput = () => {
        document.querySelectorAll('[data-enquiry-form]').forEach(formWrapper => {
            formWrapper.querySelectorAll('input[data-enquiry-items]').forEach(enquiryItemsInput => {
                fetch('/umbraco/surface/Enquiry/GetInputValue')
                    .then(response => response.text())
                    .then(data => {
                        enquiryItemsInput.value = data;
                    });
            });
        });
    };
    
    return {initBlock,handleAddClick};
})();
document.querySelectorAll('[data-enquiry-wrapper]').forEach(el => enquiry.initBlock(el));
document.querySelectorAll('[data-enquiry-button]').forEach(el => enquiry.handleAddClick(el));